<script setup lang="ts">
import { CertificatePage } from '@/functions/apply/views';
import { ARTICLE_SEO_SITE_NAME, SEO_COMMON_DESCRIPTION } from '@/utils/articleSeo';

import { useSeoMeta, useHead } from '#imports';

useSeoMeta({
  title: '収入証明書類について | dスマホローン | カードがいらないドコモのカードローン',
  description:
    '収入証明の提出が必要な場合の条件やご提出いただく収入証明書類について詳しくご案内します。お申込み内容やご利用状況によって、収入を証明する書類をご提出いただく場合がございます。' +
    SEO_COMMON_DESCRIPTION,
  keywords: 'dスマホローン,ドコモ,収入証明書',
  ogUrl: 'https://loan.docomo.ne.jp/apply/certificate/',
  ogType: 'article',
  ogTitle: '収入証明書類について | dスマホローン | カードがいらないドコモのカードローン',
  ogDescription:
    '収入証明の提出が必要な場合の条件やご提出いただく収入証明書類について詳しくご案内します。お申込み内容やご利用状況によって、収入を証明する書類をご提出いただく場合がございます。' +
    SEO_COMMON_DESCRIPTION,
  ogSiteName: ARTICLE_SEO_SITE_NAME,
  ogImage: 'https://loan.docomo.ne.jp/img/ogp.png',
});

useHead({
  link: [
    {
      rel: 'canonical',
      href: 'https://loan.docomo.ne.jp/apply/certificate/',
    },
    {
      rel: 'icon',
      href: '/img/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/img/android-chrome-192x192.png',
    },
    {
      rel: 'apple-touch-icon',
      href: '/img/apple-touch-icon.png',
    },
  ],
});
</script>

<template>
  <CertificatePage />
</template>
